
import { Component, Vue } from 'vue-property-decorator';

import { UserRoleName } from '@/lib/models';

@Component
export default class Sidebar extends Vue {
  private hasTraceAdminRole: boolean = this.hasUserRole(UserRoleName.TraceAdmin);
  private hasSupportAccessRole: boolean = this.hasUserRole(UserRoleName.SupportAccess);
  private hasCompanyAdminRole: boolean = this.hasUserRole(UserRoleName.CompanyAdmin);

  private hasUserRole(name: UserRoleName): boolean {
    return (this as any).$auth0.user[process.env.VUE_APP_AUTH0_CUSTOM_CLAIM_NAMESPACE + '/roles'].includes(name);
  }
}
